

<template>
    <div>
        <Heading
            ecommerce
            title="Request for Approval"
            :description="description"
        />
        <div class="step-4-area mx-auto text-center">
            <SendEmail 
                v-if="!emailCode" 
                :domain-email = "domainEmail"
                @setEmail = "setEmail"
                @sendEmail = "sendEmail"
                :hostname = "hostname"
            />
            <ConfirmCode 
                v-else 
                :email-code = "emailCode" 
                @setEmailCode="setEmailCode" 
                @sendEmail = "sendEmail"
                @setEmail = "setEmail"
                :email = "email"
                @saveData = "saveData"
            />
            <div v-if="user.isAdmin && !emailCode">
                <p class="c24 mt-3 p2b">OR</p>
                <button class="btn btn-green-outline" @click="saveData">
                    Skip Verification (Admin Option)
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, computed} from '@vue/composition-api'
import Heading from '../../../components/Theme/Heading'
import ConfirmCode from './confirmCode'
import SendEmail from './sendEmail'
import {ShopsService} from '../../../core/services'
import { message } from 'ant-design-vue'
import {shopUtils} from '../../../core/utils'
import {useStore} from '../../../core/hooks'

export default {
    name: 'VerifyOwnership',
    components: {
        ConfirmCode,
        SendEmail,
        Heading
    },
    props: {
        data: Object
    },
    setup(props, {emit, root}){
        const {store, state} = useStore()
        const emailCode = ref(null)
        const hostname = ref(shopUtils.handleShopUrl(props.data.domain))
        const email = ref(props.data.emails.find(item => item.includes(hostname.value)) || '')
        const user = computed(() => state.value.user)

        const description = computed( () =>
                emailCode.value ? 
                `We have sent a verifaication code to <b>${email.value}</b>. Please enter the code you received below` :
                `To verify your website ownership we'll send a verification code to the email address connected to your website (e.g. <b>team@crossprom.com</b> and <b>www.crossprom.com</b>). Confirm the email provided below or enter a new one and click the "Verify your email" button.`
        )

        const setEmailCode = val => {
            emailCode.value = val
        }

        const setEmail = val => {
            email.value = val
        }

        const domainEmail = computed(() => email.value && email.value.endsWith(hostname.value) ? email.value.replace('@'+hostname.value, "") : '')

        const sendEmail = async () => {
            const code = String(Math.floor(100000 + Math.random() * 900000))
            const emailToSendCode = user.value.isAdmin || process.env.NODE_ENV !== 'production' ? state.value.user.email : email.value
            console.log('email sent to', emailToSendCode)
            try {
                ShopsService.sendVerifyShopEmail(code, emailToSendCode)
                message.success('Verification code successfuly sent', 5)
                setEmailCode(code)
            } catch(err) {
                console.log(err.message)
                message.error('Something went wrong')
            }
        }

        const saveData = async () => {
            const data = shopUtils.shopBuilder(props.data, user.value.userId)
            try {
                const docRef = await ShopsService.save(data)
                console.log(docRef)
                await ShopsService.set(docRef, { id: docRef.id})
            } catch(e) {
                return message.error(e.message)
            }
            emit('setData', {
                ...props.data,
                verified: true
            })

            root.$sendMixpanelEvent('Shop Created', {
                Shop: props.data.title,
                Domain: props.data.domain
            })

            root.$ga.event('Add Shop', 'Shop Created', `
                Shop: ${props.data.title},
                Domain: ${props.data.domain}
            `)

            store.commit('TOGGLE_MODAL', ['success-modal', {
                title: 'Congratulations',
                subTitle: 'Your shop is verified. Please proceed to see your recommendations!"',
                btnText: 'Get Started',
                url: '/my-shops'
            }]);
                
        }

        return {
            emailCode,
            email,
            hostname,
            setEmail,
            setEmailCode,
            domainEmail, 
            description,
            sendEmail,
            saveData,
            user
        }
    }
}
</script>


<style lang="scss" scoped>
.step-4-area {
    width: 412px;
}
</style>